import React, { FC, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import PointList from '../PointList';
import Chat from '../Chat';
import { Category, InspectionDataWrapper } from 'src/api/types';

export const PaneWrapper = styled.div`
    height: 100%;
    overflow-y: auto;
    padding: 12px;
`;

interface TemplateProps {
    inspectDetail?: InspectionDataWrapper;
    category?: Category;
    playSpecificTimePeriod?: (start: number, end: number) => void;
}

const Template: FC<TemplateProps> = (props) => {
    const { inspectDetail, playSpecificTimePeriod, category } = props;

    const chatRef = useRef<any>(null);

    const [chosenId, setChosenId] = useState<number>();

    const [hitHighlightList, setHitHighlightList] = useState<string[]>([]);

    useEffect(() => {
        // 所有命中的 index
        const allIndexList = Object.keys(inspectDetail?.indexPointTag ?? {});

        // 当前分类下命中的所有 index
        const curIndexList = allIndexList.filter((index) => {
            // 当前分类下所有质检点 id
            const curPointList = category?.children?.reduce((pre, cur) => {
                return [...pre, ...(cur.pointDataList?.map((p) => p.pointId) ?? [])];
            }, [] as (number | undefined)[]);

            // 在所有命中的 index 中，寻找包含当前分类下质检点 id 的 index
            return inspectDetail?.indexPointTag?.[index]?.some((item) =>
                curPointList?.includes(item.id)
            );
        });

        setHitHighlightList(curIndexList);
    }, [category, inspectDetail]);

    const onChoose = (pointId?: number) => {
        setChosenId(pointId);

        const indexList = Object.keys(inspectDetail?.indexPointTag ?? {}).filter((key) => {
            return inspectDetail?.indexPointTag?.[key]?.some((item) => item.id === pointId);
        });

        if (indexList?.length) {
            setHitHighlightList(indexList);

            setTimeout(() => {
                chatRef.current?.scrollTo?.({
                    index: +indexList[0] - 1,
                    align: 'top',
                    behavior: 'smooth',
                });
            }, 500);
        } else {
            setHitHighlightList([]);
        }
    };

    return (
        <PaneWrapper>
            <PointList category={category} chosenId={chosenId} onChoose={onChoose} />

            <Chat
                ref={chatRef}
                detail={inspectDetail}
                inspectDataSource={inspectDetail?.inspectDataSource}
                onTimeRangeChanged={(node) => playSpecificTimePeriod?.(node.fromSec, node.endSec)}
                hitHighlightList={hitHighlightList}
            />
        </PaneWrapper>
    );
};

export default Template;
